import { faBox, faHashtag, faMapMarkerAlt, faTag } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./InventoryItem.css";

const InventoryItem = ({ item, isSelected, selectedProduct, onItemSelect }) => {
  return (
    <div className={`inventory-card ${isSelected ? "inventory-card--selected" : ""}`} onClick={() => onItemSelect(item)}>
      {/* Selection indicator */}
      {/* {isSelected && (
        <div className="selection-indicator">
          <FontAwesomeIcon icon={faCheckCircle} className="selection-icon" />
        </div>
      )} */}

      <div className="card-content">
        {/* Header with icon */}
        <div className="card-header">
          <div className={`product-icon-container ${isSelected ? "product-icon-container--selected" : ""}`}>
            <FontAwesomeIcon icon={faBox} className={`product-icon ${isSelected ? "product-icon--selected" : ""}`} />
          </div>

          <div className="product-info">
            <h3 className="product-name">{item.product_name || "Unnamed Product"}</h3>
            {/* Category badge */}
            {item.category_name || selectedProduct?.name ? (
              <div className="category-badge">
                <span className="category-badge-content">
                  <FontAwesomeIcon icon={faHashtag} className="category-icon" />
                  {item.category_name || selectedProduct?.name}
                </span>
              </div>
            ) : null}
          </div>
        </div>

        {/* Tags section */}
        {item.tags && item.tags.length > 0 && (
          <div className="tags-section">
            <div className="tags-header">
              <FontAwesomeIcon icon={faTag} className="tags-icon" />
              <span className="tags-label">Tags</span>
            </div>
            <div className="tags-container">
              {item.tags.map((tag, index) => (
                <span
                  key={index}
                  className="tag"
                  style={{
                    backgroundColor: tag.color || "#6b7280",
                    color: "white",
                  }}
                >
                  {tag.name}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Details grid */}
        <div className="details-section">
          <div className="detail-row">
            <span className="detail-label">Serial Number</span>
            <span className="detail-value detail-value--serial">{item.serial_number || "N/A"}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Quantity</span>
            <span className="detail-value detail-value--quantity">{item.available_quantity || "N/A"}</span>
          </div>

          <div className="detail-row">
            <span className="detail-label location-label">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="location-icon" />
              Location
            </span>
            <span className="detail-value detail-value--location">{item.doc_location || "N/A"}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InventoryItem;
